import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface IProps {
	settingsId: string;
	onChange: (value: string) => void;
}

export const TBankPlaceIdField: React.FC<IProps> = React.memo(({ onChange, settingsId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterTBankPlaceId') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
			onChange(valueWithoutSpaces);
			return valueWithoutSpaces;
		},
		[onChange],
	);

	return (
		<FormInput
			testId="TBankPlaceIdField"
			name={`tBankPlaceId-${settingsId}`}
			label="tBankPlaceIdLabel"
			getValueFromEvent={handleChange}
			maxLength={50}
			validationRules={validationRules}
		/>
	);
});
